export default __webpack_public_path__ + "static/media/right-white.c2659bb6.svg";